import { AT } from '../../../actions/actionTypes';
import { State, InitPL, SetItemsPL, SetModePL } from './model';
import { StateDefault } from './defaults';
import * as CallStatus from '../../../utils/callStatus';
import { getMode } from './utils';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: State = StateDefault;

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_DOWNLOAD_INIT: {
      Logger.info([AT.DIALOG_DOWNLOAD_INIT, action], LogArea.Redux);
      const { keys, groupedBy, mode }: InitPL = action.payload;
      return { ...state, keys, groupedBy, mode };
    }

    case AT.DIALOG_DOWNLOAD_SETITEMS: {
      Logger.info([AT.DIALOG_DOWNLOAD_SETITEMS, action], LogArea.Redux);
      const { keys }: SetItemsPL = action.payload;
      const mode = getMode(state.groupedBy, keys);
      return { ...state, keys, mode };
    }

    case AT.DIALOG_DOWNLOAD_SETMODE: {
      Logger.info([AT.DIALOG_DOWNLOAD_SETMODE, action], LogArea.Redux);
      const { groupedBy, mode }: SetModePL = action.payload;
      return { ...state, groupedBy, mode };
    }

    case AT.DIALOG_DOWNLOAD_FETCH: {
      Logger.info([AT.DIALOG_DOWNLOAD_FETCH, action], LogArea.Redux);
      return CallStatus.fetch(state);
    }

    case AT.DIALOG_DOWNLOAD_SUCCESS: {
      Logger.info([AT.DIALOG_DOWNLOAD_SUCCESS, action], LogArea.Redux);
      return CallStatus.success(state);
    }

    case AT.DIALOG_DOWNLOAD_ERROR: {
      Logger.info([AT.DIALOG_DOWNLOAD_ERROR, action], LogArea.Redux);
      return CallStatus.error(state, '');
    }

    default: {
      return state;
    }
  }
}
